"use strict";
/**
 * This code is ported from `@react-hookz/web` package, to avoid importing the whole package in the client bundle.
 * @see https://github.com/react-hookz/web/blob/master/src/useSyncedRef/index.ts
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSyncedRef = void 0;
const react_1 = require("react");
/**
 * Like `useRef`, but it returns immutable ref that contains actual value.
 *
 * @param value
 */
function useSyncedRef(value) {
    const ref = (0, react_1.useRef)(value);
    ref.current = value;
    return (0, react_1.useMemo)(() => Object.freeze({
        get current() {
            return ref.current;
        },
    }), []);
}
exports.useSyncedRef = useSyncedRef;
//# sourceMappingURL=useSyncedRef.js.map